__webpack_require__.p = "https://product-results.core-artifacts.com/static/";